import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import ApiService from '../../../services/ApiService';

export default function SuccessPopUp(props) {
  const { open, popupTitle, ticketNumber } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  function handleClickOnChange() {
    props.handleCloseSuccessPopUp();
    if (popupTitle.indexOf('created') !== -1) {
      props.handleEmailPopUp('create');
    } else {
      props.handleEmailPopUp('edit');
    }
  }

  function handleValidate() {
    props.handleCloseSuccessPopUp();
    ApiService.autoSendEmail(ticketNumber).then(() => {
      props.handleCloseSuccessPopUp();
    });
  }

  function closePopUp() {
    props.handleCloseSuccessPopUp();
  }

  return (
    <Dialog
      open={open}
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="md"
      classes={{ paper: classes.paper }}
    >
      <Grid container spacing={0}>
        <Grid item xs={1}>
          <MailOutlineIcon
            className={classes.mailIconButton}
            fontSize="large"
          />
        </Grid>
        <Grid item xs={11}>
          <DialogTitle>
            <Box display="flex" alignItems="center">
              <Box flexGrow={1}>
                <Typography className={classes.title}>{popupTitle}</Typography>
              </Box>
              <Box>
                <IconButton data-testid="closeBtn" onClick={closePopUp}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <DialogContentText className={classes.dialogText}>
              {t('A mail will be send to all users')} <br />
              {t('click on button change')}
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button
              data-testid="changeBtn"
              classes={{
                outlinedSecondary: classes.changeButton,
              }}
              color="secondary"
              variant="outlined"
              onClick={handleClickOnChange}
            >
              {t('Change')}
            </Button>
            <Button
              data-testid="validateBtn"
              className={classes.validateButton}
              variant="contained"
              autoFocus
              onClick={handleValidate}
              color="secondary"
            >
              {t('Validate')}
            </Button>
          </DialogActions>
        </Grid>
      </Grid>
    </Dialog>
  );
}
